import router from "../router";

function errorResponseHandler(error) {
  Vue.prototype.$Progress.fail();

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx

    // Get status code
    let statusCode = error.response.status;

    // Redirect to login at 401 (Unauthenticated user error)
    if (statusCode == 401) {
      Vue.hideAllNotify();

      if (router.currentRoute.name == "login") {
        if (error.response.data.error) {
          Vue.prototype.$snotify.error(error.response.data.error);
        }
        return false;
      }
      return router.push("login");
    }

    // Return response at 422 (validation errors)
    if ([422].includes(statusCode)) {
      return Promise.reject(error);
    }

    // Do nothing in these errors
    if ([429].includes(statusCode)) {
      return false;
    }

    if (
      error.response.data.message &&
      typeof error.response.data.message !== "undefined"
    ) {
      Vue.prototype.$snotify.error(error.response.data.message);
    }
    return Promise.reject(error);
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log("Error", error.message);
  }
  console.log(error.config);
}

export default errorResponseHandler;
